// extracted by mini-css-extract-plugin
module.exports = {"tagTypeItemList":"TagTypeItemList_tagTypeItemList__3RKcC","tagTypeItem":"TagTypeItemList_tagTypeItem__3Cyoc"};